import { render } from "./GroupInfos.vue?vue&type=template&id=9993ea0a&scoped=true"
import script from "./GroupInfos.vue?vue&type=script&lang=js"
export * from "./GroupInfos.vue?vue&type=script&lang=js"

import "./GroupInfos.vue?vue&type=style&index=0&id=9993ea0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9993ea0a"]])

export default __exports__